import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Modal, Form, Input, Row, Col, Button, Tooltip } from 'antd';
import myContext from '@/utils/createContext';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import _ from 'lodash';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import allRegex from '@/components/allRegex.js';
import { gtag } from '@/utils';

function Phone(props) {
  const intl = props.intl;
  const { formatMessage } = intl;
  const { form, initData, showDomain } = useContext(myContext);
  const { email } = initData;
  const emailRef = useRef();
  const paymentMethod = localStorage.getItem('paymentMethod');
  const onBlurCardPhone = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入手机号']);
    gtag(`${showDomain}支付页面`, ['输入手机号']);
    showDomain ? gtag(`定制支付页面`, ['输入手机号']):'';
  };
  useEffect(()=>{
    let _phoneNumber = form.getFieldValue('phoneNumber');
    if(_phoneNumber){      
      form.validateFields(['phoneNumber'],(err) => {})
    }
  },[form.getFieldValue('phoneNumber')])
  
  return (
    <div className="h5-phone">
      <FloatLabel
        form={form}
        name="phoneNumber"
        cref={emailRef}
        // label="Email"
        label={formatMessage({
          id: 'ga-checkout.phone-number',
        })}
        extra={['kon','pez'].indexOf(paymentMethod)>-1 ? formatMessage({id: 'ga-checkout.phone-number-extraTip' }): '' }
        rules={[
          {
            required: true,
            // message: `Email is required.`,
            message: formatMessage({
              id: 'ga-checkout.please-enter-phone-number',
            }),
          },
          {
            pattern: paymentMethod === 'kba'|| paymentMethod === 'afterpay'  ? allRegex.klarnaPhoneReg : allRegex.jaPhoneReg,
            // message: 'Please enter correct email address.',
            message: formatMessage({
              id: 'ga-checkout.phone-number-error',
            }),
          },
        ]}
        getValueFromEvent={e => {
          let val = e.target.value;
          let newVal = ['kon','pez'].indexOf(paymentMethod)>-1 ? val.replace(/[^0-9]/gi, ''):val; // 替换字符串中的所有的非数字
          e.target.value = newVal;
          return e.target.value;
        }}
      >
        <Input size="large" maxLength={['kon','pez'].indexOf(paymentMethod)>-1 ? 11 :64} style={{ paddingRight: '40px' }} onBlur = {onBlurCardPhone} />
      </FloatLabel>
    </div>
  );
}

export default injectIntl(Phone);
